import { hasNonEmptyValue } from 'Lib/Any';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import * as oPath from '../../../../../Lib/Object/Path/Immutable';
import { Spinner } from '../../../../Core';
import { withInjectedProps } from '../../../../Core/InjectedPropsContext';
import { ListFieldSection } from '../../../../Layout';
import { AssociatedTestType } from '../types';
import ImportedTestDetailsSection from './ImportedTestDetailsSection';
import { IWorksheetImportedTestSectionProps } from './WorksheetImportedTestSection';

let WorksheetAutoImportedTestSection: React.FC<IWorksheetImportedTestSectionProps> = ({
  importedTestResults,
  name,
  value: importedTest,
  messages,
  prefixName = (n) => n,
  createWorksheetSelector,
}) => {
  const [isImporting, setIsImporting] = useState(false);
  const hasImportedTest = hasNonEmptyValue(importedTest);
  const associatedTestTypePath = name.replace('.ImportedTest', '.AssociatedTestType');
  const associatedType = useSelector(createWorksheetSelector!(associatedTestTypePath)) as AssociatedTestType;
  const associatedTypeFromSyncModel = useSelector((s) =>
    oPath.get(s.worksheetEditor.syncModel_synced, prefixName(associatedTestTypePath))
  ) as AssociatedTestType;

  useEffect(() => {
    if (associatedType !== associatedTypeFromSyncModel) setIsImporting(true);
    else setIsImporting(false);
  }, [associatedType, associatedTypeFromSyncModel]);

  return isImporting ? (
    <div style={{ position: 'relative', height: `20px`, width: '20px' }}>
      <Spinner />
    </div>
  ) : !hasImportedTest ? (
    <ListFieldSection messages={messages} />
  ) : (
    <>
      {hasImportedTest && <ImportedTestDetailsSection importedTest={importedTest} />}
      {importedTestResults}
      {/* Shows all messages attached to the ImportedTest 
      Visible property set which shortens the length of the field if no messages are set */}
      <ListFieldSection visible={hasNonEmptyValue(messages)} messages={messages}></ListFieldSection>
    </>
  );
};

WorksheetAutoImportedTestSection = withInjectedProps(WorksheetAutoImportedTestSection);

export default WorksheetAutoImportedTestSection;
